import { useEffect } from "react";

// Run a function on mount only, centralise the ignoring of react-hooks/exhaustive-deps

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useMountEffect = effectFunction => useEffect(effectFunction, []);
